import { graphql } from "~/gql";

export const CREATE_AND_ADD_DISCOUNT = graphql(/* GraphQL */ `
  mutation createAndAddDiscount($matterId: Float!, $data: DiscountCreateInput!) {
    createAndAddDiscount(matterId: $matterId, data: $data) {
      ...DiscountParts
    }
  }
`);
